import { render, staticRenderFns } from "./SmartSearchOption.vue?vue&type=template&id=2b584514"
import script from "./SmartSearchOption.vue?vue&type=script&lang=ts"
export * from "./SmartSearchOption.vue?vue&type=script&lang=ts"
import style0 from "./SmartSearchOption.vue?vue&type=style&index=0&id=2b584514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports